import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/localization/$languageId")({
  beforeLoad: requireSuperAdmin(),
  component: () => <Outlet />,
});
